import {useContext} from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {
    propertyCardViewEvent,
    propertyCardClickEvent,
    destinationCardClickEvent,
    pageModuleViewEvent,
    propertyTileClickEvent,
    cardViewEvent,
    cardContextMenuClickEvent,
    carouselViewEvent,
    nextClick,
    previousClick,
    seeMoreCardClick,
    seeMoreButtonClick,
} from '../utils/edapLegacy/edapEventsLegacy';
import {
    getCardClickEventLabelData,
    getCardViewEventLabelData,
} from '../utils/edapLegacy/edapHelpersLegacy';

export default function useEdapEvent() {
    const context = useContext(TrackingContext);

    return {
        propertyCardViewEvent: (hit, actionLocation) =>
            propertyCardViewEvent(
                context,
                getCardViewEventLabelData(hit),
                actionLocation
            ),
        propertyCardClickEvent: (hit, actionLocation) =>
            propertyCardClickEvent(
                context,
                getCardClickEventLabelData(hit),
                actionLocation
            ),
        destinationCardClickEvent: (hit, actionLocation) =>
            destinationCardClickEvent(context, hit, actionLocation),
        pageModuleViewEvent: (actionLocation) =>
            pageModuleViewEvent(context, actionLocation),

        propertyTileClickEvent: (labelData, actionLocation) =>
            propertyTileClickEvent(context, labelData, actionLocation),

        cardViewEvent: (hit) =>
            cardViewEvent(context, getCardViewEventLabelData(hit)),

        cardContextMenuClickEvent: (hit, actionLocation) =>
            cardContextMenuClickEvent(
                context,
                getCardClickEventLabelData(hit),
                actionLocation
            ),
        carouselViewEvent: (labelData, actionLocation) =>
            carouselViewEvent(context, labelData, actionLocation),
        nextClickEvent: (actionLocation) => nextClick(context, actionLocation),
        prevClickEvent: (actionLocation) =>
            previousClick(context, actionLocation),
        seeMoreCardClickEvent: (fireSeeMoreEvent) => {
            if (fireSeeMoreEvent) {
                seeMoreCardClick(context);
            }
        },
        seeMoreButtonClickEvent: (shouldFireEvent) => {
            if (shouldFireEvent) {
                seeMoreButtonClick(context);
            }
        },
    };
}
